<template>
  <!-- ログインフォーム -->
  <div class="p-login-form">
    <login-form-title text="パスワードを忘れた方へ" />
    <!-- <form action="/api/login/pass-lost/" id="passwordForgetForm">-->
    <form id="passwordForgetForm" action="/password/email">
      <ul class="p-login-form-list">
        <li class="p-login-form-list__item">
          <input-mail :with-error-message="true" />
        </li>
      </ul>

      <div class="p-login-pass-lost">
        <div class="p-login-pass-lost__text">
          ご登録されたメールアドレスを送信してください。<br />
          パスワード再設定のメールをお送りします。<br />
        </div>
      </div>

      <ul class="p-login-form-list p-login-form-list--bottom">
        <li class="p-login-form-list__item">
          <a
            class="c-btn c-btn--blue u-w250"
            href="#"
            name="send"
            @click="send()"
          >
            <p class="c-btn__text">送信する</p>
          </a>

          <back-to-login-link :login-url="loginUrl" />
        </li>
      </ul>
    </form>
  </div>
  <!-- /ログインフォーム -->
</template>

<script>
import axios from 'axios';

export default {
  props: {
    loginUrl: String,
  },
  methods: {
    send: function (_event) {
      //event.preventDefault();

      var sendButton = $('a[name="send"]');
      var passwordForgetForm = $('#passwordForgetForm');

      // ローディング表示設定
      sendButton.addClass('is-loading').prop('disabled', 'disabled');

      // フォーム要素取得
      const data = {
        email: passwordForgetForm.find('input[name=mail]').prop('value'),
      };

      // 配信状況データの取得処理実行
      axios.post(passwordForgetForm.prop('action'),data)
        .then(res => {
          if(res.data.result == 'OK'){
            sendButton.removeClass('is-loading').prop('disabled', '');
            // エラーメッセージ表示設定
            passwordForgetForm.find('input[name=mail]')
              .closest('li')
              .find('.c-input')
              .addClass('is-error')
              .find('.c-error')
              .addClass('is-active')
              .find('.c-error__text')
              .text('パスワード再設定のメールを送信しました');
          } else {
            sendButton.removeClass('is-loading').prop('disabled', '');
            if(res.data.errors){
              for (let elementName in res.data.errors) {
                let message = res.data.errors[elementName];

                passwordForgetForm.find('input[name=' + elementName + ']')
                  .closest('li')
                  .find('.c-input')
                  .addClass('is-error')
                  .find('.c-error')
                  .addClass('is-active')
                  .find('.c-error__text')
                  .text(message);
              }
            }
          }
        })
        .catch(_e => {
          // エラーメッセージ表示設定
          passwordForgetForm.find('input[name=mail]')
            .closest('li')
            .find('.c-input')
            .addClass('is-error')
            .find('.c-error')
            .addClass('is-active')
            .find('.c-error__text')
            .text('予期せぬエラーが発生しました');
        });
    },
  },
}
</script>
